<div *ngIf="errorMessageList.length > 0 " class="error-list-conatiner">
    <nz-collapse >
      <nz-collapse-panel
        [nzHeader]="errorHeaderTitle"
        [nzActive]="errorMessagePanel.active"
        [nzShowArrow]="errorMessagePanel.arrow"
      >
        <ul>
          <li *ngFor="let error of errorMessageList">
            {{error}}
          </li>
        </ul>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
